const m11Section = {
  id: 'm11',
  name: '2027ScoresheetM11Sub1Label',
  fields: [
    {
      scoring: '2027ScoresheetM11Sub2Label',
      id: 'm11_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        },
      ]
    }
  ]
}

export default m11Section;